import { prefix } from '../../utils/index.js';
export class AtomTemplateBase {
    constructor(key, _value, _config) {
        this.key = key;
        this._value = _value;
        this._config = _config;
        Object.assign(this, _config);
        // const map = new WeakMap();
        // map.set(newAtomInstance, true);
        // map.set({ control: true }, true);
        // console.log({ key: atom.key, map });
    }
}
AtomTemplateBase.$$typeof = Symbol.for(`${prefix}/AtomTemplateBase`);
